<template>
  <div class="police">
      <SelectMonth @fMethod="getDate" :startData="startData" :endData="endData"></SelectMonth>
      <div id="userBlock" ref="chart"></div>
  </div>
</template>
<script>
import SelectMonth from './../../a-module/block-selectMonth.vue'
import {url,operate} from '@/utils/config'
import {postFun,getFun} from '@/utils/httpFun'
import { getDateFun } from '../../../../../../utils/util'
export default {
  components:{
      SelectMonth:SelectMonth,
  },
  props:{
    width:{
      type:Number,
      default:100
    }  
  },
  data: ()=>({
    startData:null,
    endData:null,
     parms:{
        endTime:"",
        startTime:"",
        timeType:1,    //1近七天 2近一个月 3近一年
     },
     interval:0,
     fontSize:10,
     align:'',
     rotateVal:'0',
     myChart:{},
     xList:[],           // x轴数据 未设置 默认值
     agentList:[],       // 代理商数据 未设置默认值
     agentName:'代理商',
     factyList:[],       // 工厂数据 未设置默认值
     facyName:'工厂',
     chargerList:[],      // 充电商 未设置默认值
     chargerName:'充电商',
     engList:[],         // 工程商数据 未设置默认值
     engName:'工程商',
     customerList:[],     // 充电商C端用户 未设置默认值
     customerName:'C端用户',


  }),
  computed: {
      refreshStr() {
         return this.$store.state.windowwidth || this.$store.state.windowwidth;
      }
   },
    watch: {
      refreshStr(val) {
         if (val) {
            this.myChart.resize()
         }
      }
   },
  mounted() {
     this.getInfo()
  },
  methods:{
    getDate(ev){
        console.log('用户获取数据',ev)
        this.endData = getDateFun(new Date(ev.endTime),'mounth')
        this.startData =  getDateFun(new Date(ev.startTime),'mounth')
       this.parms.timeType = ev.type
       let isMark = ev.type==4 &&!!ev.endTime&&!!ev.startTime 
       if(isMark){
         this.parms.endTime =  ev.endTime
         this.parms.startTime =  ev.startTime
         this.getInfo()
       }else{
          if(ev.type!=4){
            this.parms.endTime =  ev.endTime
         this.parms.startTime =  ev.startTime
            this.getInfo()
          }
       }
    },
    clear(){
        this.xList = [];
        this.agentList = [];
        this.factyList = [];
        this.chargerList = [];
        this.engList = [];
        this.customerList = [];
        this.agentName = '代理商';
        this.facyName = '工厂';
        this.chargerName = '充电商';
        this.engName = '工程商';
        this.customerName = 'C端用户';
    },
    //获取的数据
    getInfo(){

            this.clear();

            postFun(operate.USERADDCHART,this.parms,res=>{
                console.log('获取用户数据',res);
                let data = res.data
                this.setDataFun(data);
            })
      },
      setDataFun(data){
        // debugger;
        // 赋值名称
        this.agentName =`代理商(${data.agentTotal})`;
        this.chargerName =`充电商(${data.chargersUserTotal})`;
        this.facyName = `工厂(${data.factoryTotal})`;
        this.engName = `工程商(${data.engineerTotal})`;
        this.customerName = 'C端用户('+data.customerUserTotal+')';

        // 获取x轴数据
        //  getDateFun(item.time,'MM-dd',true)
        console.log(this.parms.timeType,'tiemType')
        this.xList = data.agentList.map((item) => {
            if(this.parms.timeType == '3')return getDateFun(new Date(item.time),'yyyy-MM',true);
            else return getDateFun(new Date(item.time),'MM-dd',true);
        });

        this.xList = this.xList.sort();
        

        // 赋值
        this.agentList = data.agentList.map((item) => item.value );
        this.chargerList = data.chargersUserList.map((item) => item.value );
        this.factyList = data.factoryList.map((item) => item.value );
        this.engList = data.engineerList.map((item) => item.value );
        this.customerList = data.customerUserList.map((item) => item.value );

        console.log('========',this.agentName,this.chargerName,this.factyName,this.engName,this.customerName)
        console.log('-----数据',this.agentList,this.chargerList,this.factyList,this.engList,this.customerList)
        console.log('-----x轴',this.xList)
        this.init()
      },
      init() {
            let myChart = this.$_echarts.init(document.getElementById('userBlock'))
            this.myChart = myChart
            
            var option = {
                title: {},
                tooltip: {
                    show:true,
                    trigger: 'axis',
                    position: function (pt) {
                        return [pt[0], '10%'];
                    }
                },
                legend: {
                    x: 'center',
                    // y: 'bottom',
                    bottom:'47',
                    data: [this.agentName,this.facyName,this.chargerName,this.engName,this.customerName],
                    itemGap: 30,
                    icon:"roundRect",
                    itemWidth: 16,
                    itemHeight: 10,
                    itemStyle: {
                        borderCap: 'round'
                    }
                },
                grid: { //方法 2
                    top:10,
                    left: '3',
                    right: '30',
                    bottom: '70',
                    containLabel: true
                },
                dataZoom: [
                    {
                        type: 'inside'
                    },
                    {
                        type: 'slider'
                    }
                ],
                xAxis: {
                    data: this.xList,
                    boundaryGap: false,
                    axisLine:{
                        show:false,
                    },
                    axisTick: {
                        show:false,
                        alignWithLabel: true,
                    },
                    axisLabel:{
                        interval:this.interval,
                        align:this.align,
                        textStyle:{
                            fontSize:this.fontSize,
                            // textShadowOffsetX:'20'                            
                        }
                    },
                    splitArea : {show : false}
                },
                yAxis: {
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: this.agentName,
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        data: this.agentList,
                        barWidth: 1,
                        itemStyle: {
                            color: "#FE564E",
                        },
                        lineStyle: {
                            color: '#FE564E',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(254,86,78,0.6)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(254,86,78,0.1)'
                            },
                         ])
                        },
                    },
                    {
                        name: this.facyName,
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        sampling: 'average',
                        barWidth: 1,
                        data: this.factyList,
                        itemStyle: {
                            color: "#0095FF",
                        },
                        lineStyle: {
                            color: '#0095FF',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0,149,255,0.5)'
                            }, {
                                offset: 1,
                                color: 'rgba(235,246,254,0.1)'
                            }])
                        },
                    },
                    {
                        name: this.customerName,
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        sampling: 'average',
                        barWidth: 1,
                        data: this.customerList,
                        itemStyle: {
                            color: "rgba(255, 147, 70)",
                        },
                        lineStyle: {
                            color: 'rgba(255, 147, 70)',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(255, 147, 70,0.5)'
                            }, {
                                offset: 1,
                                color: 'rgba(255, 147, 70,0.1)'
                            }])
                        },
                    },
                    {
                        name: this.engName,
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        sampling: 'average',
                        barWidth: 1,
                        data: this.engList,
                        itemStyle: {
                            color: "rgb(218, 167, 254)",
                        },
                        lineStyle: {
                            color: 'rgb(218, 167, 254)',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(218, 167, 254,0.5)'
                            }, {
                                offset: 1,
                                color: 'rgba(218, 167, 254,0.1)'
                            }])
                        },
                    },
                    {
                        name: this.chargerName,
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        sampling: 'average',
                        barWidth: 1,
                        data: this.chargerList,
                        itemStyle: {
                            color: "rgba(0, 213, 115)",
                        },
                        lineStyle: {
                            color: 'rgba(0, 213, 115)',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0, 213, 115,0.5)'
                            }, {
                                offset: 1,
                                color: 'rgba(0, 213, 115,0.1)'
                            }])
                        },
                    } 
                ]
            }
            this.myChart.setOption(option);
        },
  },
}
</script>
<style lang="scss" scoped>
    #userBlock{
       width: 100%;
       height:268px;
       margin-top: 20px;
    }
</style>
